import { FC } from 'react';
import Buttons from '@components/Buttons';
import { m } from 'framer-motion';
import XCircle from '@components/Icons/XCircle';
import useDismissedMessages from '@providers/Messages/useDismissedMessages';
import Noodle from '@/components/Icons/Noodle';

import s from './GetNoodleApp.module.scss';

interface Props {
  onClick: () => void;
}

export const APP_DISMISS_KEY = 'creator-dashboard-web-app';

export const NoodleIconWithBadge: FC<{ isInline?: boolean, showBadge?: boolean }> = ({ isInline, showBadge = true }) => (
  <div className={isInline ? s.logoInline : s.logo}>
    <Noodle width={56} height={56} />
    {showBadge && <m.div
      initial={{ scale: 0 }}
      animate={{
        scale: 1,
        transition: {
          delay: 2,
        },
      }}
      className={s.badge}
    >
      1
    </m.div>}
  </div>
);

const GetNoodleApp: FC<Props> = ({ onClick }) => {
  const { dismissMessage, isMessageDismissed, isInitialized } = useDismissedMessages();

  if (isMessageDismissed(APP_DISMISS_KEY) || !isInitialized) return null;
  return (
    <m.div
      className={s.getNoodleApp}
      initial={{ opacity: 0, y: -40 }}
      animate={{
        opacity: 1,
        transition: {
          duration: 1,
          type: 'spring',
        },
        y: 0,
      }}
    >
      <Buttons
        isWrapper
        ariaLabel="Dismiss"
        onClick={() => {
          dismissMessage(APP_DISMISS_KEY);
        }}
      >
        <XCircle weight="fill" size={24} />
      </Buttons>
      <NoodleIconWithBadge isInline />
      <h1>Install the Glade app</h1>
      <Buttons isFullWidth onClick={onClick}>
        Get the Glade app
      </Buttons>
    </m.div>
  );
};

export default GetNoodleApp;
